import { render, staticRenderFns } from "./NuovaPrenotazionePaziente.vue?vue&type=template&id=05411d42&"
import script from "./NuovaPrenotazionePaziente.vue?vue&type=script&lang=js&"
export * from "./NuovaPrenotazionePaziente.vue?vue&type=script&lang=js&"
import style0 from "./NuovaPrenotazionePaziente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports